document.addEventListener('DOMContentLoaded', function() {

  function hideVariantElements(container) {
    if (!container) return;

    // Hide quantity
    container.querySelectorAll('input[name="quantity"], .product-form__quantity, .quantity-selector')
      .forEach(el => el.style.display = 'none');

    // Hide variant prices
    container.querySelectorAll('.product__price, .product-form__price, .product-form__price--current, .product-form__price--original')
      .forEach(el => el.style.display = 'none');

    // Hide total price / variant total
    container.querySelectorAll('.product-form__total, .variant-total')
      .forEach(el => el.style.display = 'none');
  }

  // Apply to all product forms
  const productForms = document.querySelectorAll('product-form');

  productForms.forEach(form => {
    // Initial hide
    hideVariantElements(form);

    // Listen for any changes inside the form (variant selection)
    form.addEventListener('change', () => hideVariantElements(form));
    form.addEventListener('click', (e) => {
      if (e.target.closest('.swatch, select')) {
        setTimeout(() => hideVariantElements(form), 50);
      }
    });

    // Mutation observer to catch dynamically inserted elements
    const observer = new MutationObserver(() => hideVariantElements(form));
    observer.observe(form, { childList: true, subtree: true });
  });
});